import styled from 'styled-components'

export const Input = styled.input`
  width: 100%;
  padding: 0.625rem 0.875rem;
  border: 1px solid ${props => props.theme.colors.border.medium};
  border-radius: ${props => props.theme.radius.input};
  font-size: 0.875rem;
  font-family: ${props => props.theme.typography.fontFamily};
  background: ${props => props.theme.colors.background.secondary};
  color: ${props => props.theme.colors.text.primary};
  transition: ${props => props.theme.transitions.default};

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.text.primary};
    background: ${props => props.theme.colors.background.primary};
  }

  &::placeholder {
    color: ${props => props.theme.colors.text.muted};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  /* Remove number input arrows/spinners */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type=number] {
    -moz-appearance: textfield;
  }
`
